<div class="sh-template-stack">
    <div class="sh-template-stack__item" style="margin-bottom: 0">
        <div class="sh-form-row-with-action" *ngFor="let rowFormGroup of formArray.controls; let i = index; let first = first">
            <div class="sh-form-row-with-action__inputs">
                <div class="sh-form-row-with-action__inputs__item">
                    <sh-form-multi-select
                        [id]="'row-' + i + '-strategy'"
                        [label]="first ? ('advanced-search.strategy.label' | translate) : undefined"
                        [control]="rowFormGroup.get('Strategy')"
                        [options]="strategyOptions"
                        [limitHeightToViewport]="true"
                        [inOverflownContainer]="true"
                    ></sh-form-multi-select>
                </div>
                <div class="sh-form-row-with-action__inputs__item">
                    <sh-form-multi-select
                        [id]="'row-' + i + '-field'"
                        [label]="first ? ('advanced-search.type.label' | translate) : undefined"
                        [control]="rowFormGroup.get('Field')"
                        [options]="fieldOptions"
                        [limitHeightToViewport]="true"
                        [inOverflownContainer]="true"
                    ></sh-form-multi-select>
                </div>
                <div class="sh-form-row-with-action__inputs__item">
                    <sh-form-multi-select
                        [id]="'row-' + i + '-operator'"
                        [label]="first ? ('advanced-search.operator.label' | translate) : undefined"
                        [control]="rowFormGroup.get('Operator')"
                        [options]="operatorOptions"
                        [limitHeightToViewport]="true"
                        [inOverflownContainer]="true"
                    ></sh-form-multi-select>
                </div>
                <div class="sh-form-row-with-action__inputs__item">
                    <sh-form-text-input
                        [id]="'row-' + i + '-value'"
                        [label]="first ? ('advanced-search.value.label' | translate) : undefined"
                        [control]="rowFormGroup.get('Value')"
                        (keyup.enter)="onSearch()"
                    >
                    </sh-form-text-input>
                </div>
            </div>
            <div class="sh-form-row-with-action__actions">
                <div class="sh-form-row-with-action__actions__item" *ngIf="!first || formArray.controls.length > 1">
                    <button class="sh-pure-icon-button sh-input-field-with-action__action" (click)="removeRow(i)">
                        <svg sh-icon [name]="'minus'" aria-hidden="true" class="sh-icon-button__icon"></svg>
                    </button>
                </div>
                <div class="sh-form-row-with-action__actions__item">
                    <button class="sh-pure-icon-button sh-input-field-with-action__action" (click)="addRow(i + 1)">
                        <svg sh-icon [name]="'add'" aria-hidden="true" class="sh-icon-button__icon"></svg>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="sh-template-stack__item">
        <div class="sh-clear-margin sh-action-group -sh-align-end">
            <sh-action-item [item]="searchActionItem$ | async"></sh-action-item>
        </div>
    </div>

    <div class="sh-template-stack__item" *ngIf="searchTrigger$ | async">
        <ng-container *ngIf="results$ | async; else initialLoading">
            <med-webservice-list
                [webserviceConfig]="webserviceConfig"
                [isLoading]="lookupLoading$ | async"
                [paginatedResults]="results$ | async"
                (paginationChange)="onPaginationChange($event)"
                (selected)="onSelection($event)"
            ></med-webservice-list>
        </ng-container>
    </div>
</div>

<ng-template #initialLoading>
    <div class="sh-card-table-wrapper">
        <table class="sh-card-table">
            <thead>
                <th scope="col"></th>
            </thead>
            <tbody>
                <tr id="generic-list-loading-row">
                    <td [attr.colspan]="1">{{ "ui.loading" | translate }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>
